import React, { useContext } from 'react';
import { Upload, Button } from 'antd';
import { FolderOutlined, FileImageOutlined, UploadOutlined } from '@ant-design/icons';
import EndPoints from '../EndPoints';
import UploadService from '../services/UploadService';
import Analytics from '../services/Analytics';
import { CompressionModeContext } from '../context/CompressionModeContextProvider';

const UploadButton = props => {
	const { mode } = useContext(CompressionModeContext);
	const { size, type, className, text, directory } = props;
	let icon;
	if (text.toLowerCase() === 'upload images') {
		icon = <UploadOutlined />;
	} else if (text === 'Folder') {
		icon = <FolderOutlined />;
	} else {
		icon = <FileImageOutlined />;
	}
	function onClick() {
		if (directory) {
			Analytics.onFolderUpload();
		}
	}
	return (
		<Upload
			accept=".png, .jpg, .jpeg"
			showUploadList={false}
			action={EndPoints.FileCompression}
			onChange={UploadService.onFileChange}
			beforeUpload={UploadService.beforeUpload}
			data={{ ...mode, folder: directory }}
			multiple
			directory={directory}
		>
			<Button
				onClick={onClick}
				type={type}
				className={className}
				size={size}
				icon={icon}
			>
				{text}
			</Button>
		</Upload>
	);
};

export default UploadButton;



// WEBPACK FOOTER //
// ./src/components/UploadButton.js